export default __webpack_public_path__ + "static/media/facet_icon.f9cd447d.svg";